__turbopack_context__.v({
  "description": "lqyM6W_description",
  "descriptionSuccess": "lqyM6W_descriptionSuccess",
  "formGroup": "lqyM6W_formGroup",
  "label": "lqyM6W_label",
  "labelSucces": "lqyM6W_labelSucces",
});
